import React, {useEffect, useMemo, useState} from 'react';
import UtcToLocal from "../../components/UtcToLocal";
import {capitalizeFirstLetters, formatAccount} from "../../features/ValueFormater";
import TransferListSkeleton from "../../components/skeletons/TransferListSkeleton";
import {usePagination, useTable} from "react-table";
import RecordsMessage from "../../components/RecordsMessage";
import Table from "../../components/Table";
import Pagination from "../../components/Pagination";
import PaymentRequestAPI from "../../api/PaymentRequestAPI";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons";

function PendingRequests({setActiveButton}) {
    const [totalNbPage, SetTotalNbPage] = useState(1);
    const [selectedPage, setSelectedPage] = useState(1);
    const [activeRowIndex, setActiveRowIndex] = useState(-1);

    const {
        GetPaymentRequest,
        RemindPaymentRequest,
        paymentRequests,
        requestLoading,
        totalNbOfPage,
        totalCount
    } = PaymentRequestAPI();

    useEffect(() => {
        GetPaymentRequest(selectedPage);
    }, [selectedPage]);

    useEffect(() => {
        if (paymentRequests?.length > 0)
            SetTotalNbPage(totalNbOfPage);
    }, [paymentRequests]);

    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const columns = useMemo(() => [
        {
            Header: "Transaction",
            accessor: "Transaction",
        },
        {
            Header: "Date",
            accessor: "Date",
            Cell: ({value}) => {
                return <UtcToLocal utcTimestamp={value} options={options}/>;
            }
        },
        {
            Header: "",
            accessor: "details",
            Cell: ({row}) => {
                return <button className="showmore" onClick={() => {
                    setActiveRowIndex(row.index)
                }}><FontAwesomeIcon icon={faArrowDown}/></button>
            },
        },
        {
            Header: "Recipient",
            accessor: "Recepient",
            Cell: ({value}) => {
                return capitalizeFirstLetters(value);
            }
        },
        {
            Header: "Amount",
            accessor: "Amount",
            Cell: ({value, row}) => {
                const currencyId = row.original?.Currency === "USD" ? 1 : 2;
                return <span>{formatAccount(value, currencyId)}</span>
            }
        },
        {
            Header: "Reason",
            accessor: "Reason",
        },
        {
            Header: "Status",
            accessor: "Status",
            Cell: ({value}) => {
                if (value === "Pending") {
                    return <button style={{
                        color: "white",
                        fontFamily: "Poppins Medium ",
                        borderRadius: "20px",
                        fontSize: "12px",
                        width: "100px",
                        padding: "3px 0",
                        backgroundColor: "#D3AA00"
                    }}>{capitalizeFirstLetters(value)}</button>;
                } else {
                    return value;
                }
            }
        },
        {
            Header: "",
            accessor: "StatusDesc",
        },
        {
            Header: "",
            accessor: "remind",
            Cell: ({row}) => {
                if (row.original.ShowRemindButton)
                    return (<button
                        className="remind-btn"
                        onClick={async () => {
                            await RemindPaymentRequest(row.original?.Transaction);
                        }}
                    >Remind</button>)
                else
                    return (<></>)


            }
        }
    ], [paymentRequests]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow
    } = useTable({columns, data: paymentRequests || []}, usePagination);

    return (
        <div>
            {
                requestLoading ?
                    <TransferListSkeleton/>
                    :
                    <>
                    <div className="tableTop">
                        <RecordsMessage totalCount={totalCount} selectedPage={selectedPage} records="Payment Requests"/>
                        {
                            sessionStorage.getItem("EntityRole")!== "VIEWER" ? (
                                <button className="export" onClick={() => {
                                    setActiveButton({ name: "Send Payment Request" });
                                }}>+ NEW REQUEST
                                </button>
                            ) : ( <></>)
                        }
                    </div>
                        <Table
                            headerGroups={headerGroups}
                            page={page}
                            prepareRow={prepareRow}
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            totalNbPage={totalNbPage}
                            activeRowIndex={activeRowIndex}
                        />
                        <Pagination
                            getData={GetPaymentRequest}
                            totalNbPage={totalNbPage}
                            method="bankTransfer"
                            selectedPage={selectedPage}
                            setSelectedPage={setSelectedPage}
                        />
                    </>
            }
        </div>
    );
}

export default PendingRequests;
